// extracted by mini-css-extract-plugin
module.exports = {"button":"RightActions_button__BFWHH","menuIcon":"RightActions_menuIcon__2T0xJ","openButton":"RightActions_openButton__20bFZ"};